import { Link, useSearchParams } from 'react-router-dom';
import RegisterForm from './RegisterForm';
import TeacherJoinPage from './TeacherJoinPage';

export default function RegisterPage() {
  const [searchParams] = useSearchParams();
  const teacherParam = (searchParams.get('teacher') || '').trim();
  const parentToken = (searchParams.get('parent') || '').trim();
  const asParent = searchParams.get('as') === 'parent';
  const isParentForm = Boolean(parentToken) || asParent;

  if (teacherParam) {
    return <TeacherJoinPage />;
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h2>{isParentForm ? 'Регистрация родителя' : 'Регистрация'}</h2>
        <p className="auth-subtitle">
          {parentToken
            ? 'Создайте аккаунт родителя, примите пользовательское соглашение и договор-оферту, затем привяжитесь к ученику'
            : asParent
              ? 'Создайте аккаунт, примите пользовательское соглашение и договор-оферту, затем пригласите ребёнка ссылкой'
              : 'Создайте аккаунт и примите пользовательское соглашение. Договор на занятия заключает родитель'}
        </p>
        {parentToken && (
          <div className="alert alert-info" style={{ marginBottom: '1rem' }}>
            После регистрации откроется короткая анкета родителя.
          </div>
        )}
        <RegisterForm parentToken={parentToken || undefined} asParent={asParent} />
        <p className="auth-link">
          {isParentForm ? (
            <>
              Регистрируетесь как ученик? <Link to="/register">Форма ученика</Link>
              <br />
            </>
          ) : (
            <>
              Вы родитель?{' '}
              <Link to="/register?as=parent">Зарегистрироваться и пригласить ребёнка</Link>
              <br />
            </>
          )}
          Уже есть аккаунт?{' '}
          <Link
            to={
              parentToken
                ? `/login?next=${encodeURIComponent(`/parent-invite/${parentToken}`)}`
                : '/login'
            }
          >
            Войти
          </Link>
        </p>
      </div>
    </div>
  );
}
